import { __assign } from 'tslib';
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';

var OptionBase = function (_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 48 : _d, className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, multiple = _a.multiple, mobile = _a.mobile, Checkmark = _a.Checkmark, innerProps = _a.innerProps, dataTestId = _a.dataTestId, styles = _a.styles;
    var content = children || option.content || option.key;
    var _e = option.showCheckMark, showCheckMark = _e === void 0 ? true : _e;
    return (React.createElement("div", __assign({}, innerProps, { className: cn(styles.option, styles[SIZE_TO_CLASSNAME_MAP[size]], className, (_b = {},
            _b[styles.highlighted] = !mobile && highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b)), "data-test-id": dataTestId }),
        Checkmark && showCheckMark && (React.createElement(Checkmark, { disabled: disabled, selected: selected, multiple: multiple, position: 'before' })),
        React.createElement("div", { className: cn(styles.content, (_c = {},
                _c[styles.textContent] = !isValidElement(content),
                _c)) }, content),
        Checkmark && showCheckMark && (React.createElement(Checkmark, { disabled: disabled, selected: selected, multiple: multiple, position: 'after' }))));
};

export { OptionBase };
